export default "__VITE_ASSET__DgPVOTgs__"